// Draft of the "new project" wizard, so a closed window or an Excel crash does not lose the input.
const KEY = "boq.setupDraft";
const MAX_AGE_MS = 7 * 24 * 3600 * 1000;

const defaultStorage = () => {
  try {
    return globalThis.localStorage || null;
  } catch {
    return null;
  }
};

/** { form, doc, stepKey, treesTouched, savedAt } or null when there is no usable draft. */
export function loadDraft(storage = defaultStorage(), now = Date.now()) {
  try {
    const d = JSON.parse(storage?.getItem(KEY) || "null");
    if (!d || !d.doc?.site || typeof d.doc.trees !== "object" || !d.form) return null;
    if (now - new Date(d.savedAt).getTime() > MAX_AGE_MS) return null;
    return d;
  } catch {
    return null;
  }
}

export function saveDraft({ form, doc, stepKey, treesTouched }, storage = defaultStorage(), now = Date.now()) {
  try {
    storage?.setItem(KEY, JSON.stringify({ form, doc, stepKey, treesTouched: !!treesTouched, savedAt: new Date(now).toISOString() }));
  } catch {
    /* storage full or blocked — the draft is a convenience only */
  }
}

export function clearDraft(storage = defaultStorage()) {
  try {
    storage?.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
